<div class="timeline-steps-container">
  @if (title) {
    <div class="timeline-title">
      <h2>{{ title | translate }}</h2>
      @if (subtitle) {
        <p>{{ subtitle | translate }}</p>
      }
    </div>
  }

  <div class="timeline-wrapper">
    <div class="timeline-steps">
      @for (step of steps; track step.number) {
        <div class="timeline-step">
          <div class="step-circle-wrapper">
            <div class="step-circle">
              <span class="step-number">{{ step.number }}</span>
            </div>
          </div>
          <div class="step-content">
            <h4 class="step-title" [attr.data-translation-key]="step.titleKey">
              {{ step.titleKey | translate }}
            </h4>
            @if (showDescription && step.descriptionKey) {
              @if (step.link) {
                <a [href]="step.link" target="_blank" rel="noopener noreferrer" class="step-description step-link" [attr.data-translation-key]="step.descriptionKey">
                  {{ step.descriptionKey | translate }}
                </a>
              } @else {
                <p class="step-description" [attr.data-translation-key]="step.descriptionKey">
                  {{ step.descriptionKey | translate }}
                </p>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
